export default {
  name: {
    short: 'BEC',
    long: 'INSTALACIONES BEC'
  }
}



// WEBPACK FOOTER //
// ./src/config/app.js